import { apiClient } from '@/api/client';
import type { CreateItem, ItemModel, RegexTestResult, UpdateItem } from '@/types/categories.types';

/** Admin-only endpoints (`app-admin`); changing another author's item needs `app-superadmin`. */
export const itemsApi = {
  // GET /items — ordered by creation (seeds in design order, new ones last).
  list: async (): Promise<ItemModel[]> => {
    const { data } = await apiClient.get<ItemModel[]>('/items');
    return data;
  },

  // POST /items → 201; 409 id exists; 422 invalid id/regex/empty config.
  create: async (body: CreateItem): Promise<ItemModel> => {
    const { data } = await apiClient.post<ItemModel>('/items', body);
    return data;
  },

  // PATCH /items/{id} → 200; 403 not own (admin).
  update: async (id: string, body: UpdateItem): Promise<ItemModel> => {
    const { data } = await apiClient.patch<ItemModel>(`/items/${id}`, body);
    return data;
  },

  // DELETE /items/{id} → 204; 403 not own (admin).
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/items/${id}`);
  },

  // PUT / DELETE /items/{id}/categories/{key} → 200, idempotent; any admin, any item.
  addCategory: async (id: string, key: string): Promise<ItemModel> => {
    const { data } = await apiClient.put<ItemModel>(`/items/${id}/categories/${key}`);
    return data;
  },
  removeCategory: async (id: string, key: string): Promise<ItemModel> => {
    const { data } = await apiClient.delete<ItemModel>(`/items/${id}/categories/${key}`);
    return data;
  },

  // POST /items/regex-test — Python `re`, case-insensitive.
  regexTest: async (pattern: string, text: string): Promise<RegexTestResult> => {
    const { data } = await apiClient.post<RegexTestResult>('/items/regex-test', { pattern, text });
    return data;
  },
};
